'use strict';

import React, { Component, Fragment } from 'react'

import Slider from 'react-slick'

import _ from 'lodash'

import Layout from '@Layout/ECFront'

import getErrorsFromResponse from '@/Form/Functions/getErrorsFromResponse'
import FrontCustomQuote      from '@/CustomQuote/FrontCustomQuote'
import getFormStatus         from '@/Form/Functions/getFormStatus'
import HolidaysMessage       from '@/HolidaysMessage'
import GMap                  from '@/Maps/GMap'

import Loader from '@Pure/Loader'
import Image  from '@Pure/Image'
import Link   from '@Pure/Link'

import { isProductAbondable, safeNumeral, formatNum, getOnlineType } from '@root/utility'

const firstBy = window.firstBy;

const moment = window.moment;

moment.locale('fr');

const numeral = window.numeral;

numeral.locale('en');

const { app, qwest } = window;

export default class FrontProductPage extends Component
{
	constructor (props)
	{
		super(props);

		this.state =
		{
			product: { },
			references: [],
			loading: false,
			can_pay: true
		};

		this.addCart               = this.addCart.bind(this);
		this.getPricesHeader       = this.getPricesHeader.bind(this);
		this.getPrices             = this.getPrices.bind(this);
		this.handleSessionChange   = this.handleSessionChange.bind(this);

		this.gmap_rdy = false;

		this.displayed_columns =
		{
			date: true,
			ticket_type: true,
			age: true,
			position: true,
			validity_start: true,
			validity_date: true
		};
	}

	pathname = document.location.pathname;

	componentDidUpdate (prev_props, prev_state)
	{
		const component = this, props = this.props, state = this.state;

		if (window.objectFitImages instanceof Function)
		{
			window.objectFitImages();
		}

		if (component.pathname !== document.location.pathname)
		{
			component.pathname = document.location.pathname;

			component.init();
		}
	}

	componentDidMount ()
	{
		if (window.objectFitImages instanceof Function)
		{
			window.objectFitImages();
		}
	}

	UNSAFE_componentWillMount ()
	{
		const component = this, props = this.props;

		app.resetFunctions();

		app.push(
		{
			event: 'sessionChange',
			cb: component.handleSessionChange
		});

		component.init();
	}

	init = () =>
	{
		const component = this, props = this.props, state = this.state;

		let id = document.location.pathname.split('/');

		id = id[id.length-1] ? id[id.length-1] : id[id.length-2];

		component.readNewProductNotification();

		let filter_query =
		{
			id: id
		};

		let tabs =
		[
			{ name: 'prices', label: 'Prix' },
			{ name: 'places', label: 'Localisation' },
			{ name: 'artist', label: 'Artiste' },
			{ name: 'images', label: 'Images' },
			{ name: 'custom_quote', label: 'Demande de devis' }
		];

		component.setState(
		{
			loading: true,
			active_tab: 'prices',
			tabs: tabs
		});

		component.handleSessionChange();

		qwest.post('/CMS/getAll',
		{
			model: 'product',
			filter_query: JSON.stringify(filter_query)
		})
		.then(function (xhr, response)
		{
			let product = response.data[0];

			const references = response.references || [];

			if (Array.isArray(product.custom_quotes))
			{
				product.custom_quotes = product.custom_quotes.map(function (id)
				{
					let quote = (references
					.find(data => data.model === 'customquote') || { data: [] })
					.data.find(quote => quote.id === id);

					return quote ? quote : id;
				});
			}

			if (product.national_brand && !product._national_brand)
			{
				let national_brand = app.getReferedValue(
				{
					model: 'NationalBrand'.toLowerCase(),
					references: references,
					id: product.national_brand
				});

				if (national_brand?.id)
				{
					product._national_brand = national_brand;
				}
			}

			if (!product._places)
			{
				(product.places || []).forEach(function (place_id)
				{
					let place = app.getReferedValue(
					{
						model: 'place',
						references: references,
						id: place_id
					});

					if (place.id)
					{
						product._places = product._places || [];

						product._places.push(_.cloneDeep(place));
					}
				});
			}

			if (!product._artist)
			{
				let artists = references.find(data => data.model === 'artist');

				artists = artists ? (artists.data || []) : [];

				let product_artist = artists.find(data => data.id === product.artist);

				if (product_artist)
				{
					product._artist = _.cloneDeep(product_artist);
				}
			}

			if (!product._theme)
			{
				(product.theme || []).forEach(function (theme_id, key)
				{
					let theme = app.getReferedValue(
					{
						model: 'showtheme',
						references: references,
						id: theme_id
					});

					if (theme.id)
					{
						product._theme = product._theme || [];

						product._theme.push(_.cloneDeep(theme));
					}
				});
			}

			if (!product._public)
			{
				let product_public = app.getReferedValue(
				{
					model: 'public',
					references: references,
					id: product.client_public
				});

				if (product_public.id)
				{
					product._public = _.cloneDeep(product_public);
				}
			}

			component.setState(
			{
				product: product,
				references: references,
				loading: false
			});
		})
		.catch(function (error, xhr, response)
		{
			console.error(xhr, response, error);

			component.setState(
			{
				loading: false
			});

			app.ajaxRedirectLogin(response);
		});
	}

	readNewProductNotification = (e) =>
	{
		const component = this, props = this.props, state = this.state;

		let id = document.location.pathname.split('/');

		id = id[id.length-1] ? id[id.length-1] : id[id.length-2];

		qwest.post('/notifications/read',
		{
			patterns: ['new_product_' + id]
		})
		.catch(function (error, xhr, response)
		{
			console.error(response?.error || response?.raw || error);

			component.setState(
			{
				...getErrorsFromResponse(
				{
					response: response
				})
			});
		});

		qwest.post('/notifications/read',
		{
			patterns: ['updated_product_' + id]
		})
		.catch(function (error, xhr, response)
		{
			console.error(response?.error || response?.raw || error);

			component.setState(
			{
				...getErrorsFromResponse(
				{
					response: response
				})
			});
		});
	}

	componentWillUnmount ()
	{
		const component = this, props = this.props;

		app.push(
		{
			event: 'sessionChange',
			cb: component.handleSessionChange
		});
	}

	handleSessionChange ()
	{
		const component = this, props = this.props, state = this.state;

		const permissions = app.state.session?.permissions || { };

		const is__admin = permissions.title === 'Membre de synergies';

		const can_access_partners = is__admin ? true : [true, 'true']
		.includes(permissions.access_partners);

		component.setState(
		{
			permissions: permissions,
			can_pay: permissions.pay,

			is__admin: is__admin,
			can_access_partners: can_access_partners
		});

		if (!app.state.session.user_abondement) return;

		if (!app.state.session.EC) return;

		let id = document.location.pathname.split('/');

		id = id[id.length-1] ? id[id.length-1] : id[id.length-2];

		qwest.post('/CMS/getAll',
		{
			model: 'abondement',
			filter_query: JSON.stringify(
			{
				EC: app.state.session.EC.id,
				type: 'product',
				products: id
			})
		})
		.then(function (xhr, response)
		{
			let abondement = response.data[0], product_id = id;

			if (!abondement || abondement.qty <= 0) return;

			let recurrence = abondement.recurrence || 'unique';

		// Get abondement already used by the user for this product
			let used = (app.state.session.user_abondement.catalog_used || [])
			.filter(function (user_product_abonded)
			{
				const product_id = user_product_abonded.product;

				return (abondement.products || []).includes(product_id);
			});

			let qty_used = numeral(0);

		// If abondement had a recurrence, base used on it.
			if (recurrence !== 'unique')
			{
				used = used
				.filter(function (data)
				{
					return moment(data.date).isSame(moment(), recurrence);
				});
			}

			used.forEach(function (used_abondement, index)
			{
				qty_used.add(used_abondement.qty || 0);
			});

			const remaining = numeral(safeNumeral(abondement.qty))
			.subtract(qty_used.value())
			.format('0');

			if (remaining > 0 === false)
			{
				component.setState(
				{
					abondement: undefined,
					used_abondement_count: 0
				});
			}
			else
			{
				component.setState(
				{
					abondement: response.data[0],
					used_abondement_count: qty_used.value()
				});
			}

		})
		.catch(function (error, xhr, response)
		{
			app.ajaxRedirectLogin(response);

			console.error(error);
		});
	}

	addCart (price)
	{
		const component = this, props = this.props, state = this.state;

		let product = _.cloneDeep(state.product);

		if (state.abondement)
		{
			let abondement =
			{
				data: _.cloneDeep(state.abondement),
				used: state.used_abondement_count
			};

			product._abondement = abondement;
		}

		product.cart_price = _.cloneDeep(price);

		delete product.prices;

		let price_value = String(product.cart_price.price);

		let comma = ',', cents;

		if (price_value.indexOf('.') !== -1) comma = '.';

		if (price_value.indexOf(comma) !== -1)
		{
			cents = price_value.split(',')[1];

			if (cents.length === 1)
			{
				cents = cents + '0';
			}
			else if (cents.length > 2)
			{
				cents = cents.slice(0, 2);
			}
		}

		product.cart_price.price = price_value.split(comma)[0] + cents || '00';

		if ([true, 'true'].includes(product.cart_price.online_ticket))
		{
			product.cart_onlineTicket = true;
		}

		app.emit('open__CartModal',
		{
			product: product,
			source: 'productPage'
		});
	}

	getPricesHeader ()
	{
		const component = this, props = this.props, product = this.state.product;

		let prices_header =
		[
			{
				name: 'date',
				label: 'Date',
				order: 10
			},
			{
				name: 'ticket_type',
				label: 'Type de billet',
				order: product.pricing_type === 'parc_product' ? 1 : 20
			},
			{
				name: 'position',
				label: 'Placement',
				order: 30
			},
			{
				name: 'age',
				label: 'Age',
				order: 40
			},
			{
				name: 'validity_start',
				label: 'Début de validité',
				order: 50
			},
			{
				name: 'validity_date',
				label: 'Fin de validité',
				order: 60
			},
			{
				name: 'price',
				label: 'Prix',
				order: 70
			}
		]
		.sort((a, b) => a.order < b.order ? -1 : 1);

		prices_header = prices_header
		.filter(function (column)
		{
			if (!product.prices) return false;

			if (column.name === 'price') return true;

		// Hidden columns for show products
			if (product.pricing_type === 'show_product')
			{
				if (['ticket_type', 'validity_start', 'validity_date'].includes(column.name))
				{
					component.displayed_columns[column.name] = false;

					return false;
				}
			}
		// Hidden columns for parc products
			else if (product.pricing_type === 'parc_product')
			{
				if (['position'].includes(column.name))
				{
					component.displayed_columns[column.name] = false;

					return false;
				}
			}
		// Hidden columns for simple products
			else if (product.pricing_type === 'simple_product')
			{
				if (['date', 'age', 'position'].includes(column.name))
				{
					component.displayed_columns[column.name] = false;

					return false;
				}
			}

		// all columns empty => undefined
			let filled_column = product.prices.find(function (price)
			{
				if (!price[column.name] || ['false', 'null'].includes(price[column.name]))
				{
					return false;
				}

				return true;
			});

			if (typeof filled_column === 'undefined')
			{
				component.displayed_columns[column.name] = false;

				return false;
			}

			return true;
		})
		.map(function (column)
		{
			let class_name = 'c-pricing__element c-pricing__element-header';

			class_name += ' ' + column.name;

			let output =
			(
				<div className={ class_name } key={ column.name }>
					<div className="c-pricing__value">
						{ column.label }
					</div>
				</div>
			);

			return output;
		});

		return prices_header;
	}

	getPrices ()
	{
		const component = this, props = this.props, product = this.state.product;
		const state = this.state;

		let prices = _.cloneDeep(product.prices || []);

		let today = moment();

		prices = prices
		.filter(function (price)
		{
		// Hide based on qty (no qty -> qty === '' -> ignored)
			if (['0', 0].includes(price.qty) || price.qty < 0)
			{
				return false;
			}

		// Hide based on validity date
			if (['simple_product', 'parc_product'].includes(product.pricing_type) &&
				price.validity_date && moment(price.validity_date).isBefore(today))
			{
				return false;
			}

		// Hide based on date
			if (product.pricing_type === 'show_product' &&
				price.date && moment(price.date).isBefore(today))
			{
				return false;
			}

			return true;
		});

		let grouped_prices = [];

	// Group prices
		prices
		.filter(price => ['true', true].includes(price.disabled) === false)
		.forEach(function (price, index)
		{
			let parent_price = grouped_prices.find(function (grouped_price)
			{
			// If price has a position, same is required
				if (grouped_price.position || price.position)
				{
					if (price.position !== grouped_price.position)
					{
						return false;
					}
				}

			// If price has a date, same date is required
				if (grouped_price.date || price.date)
				{
					if (price.date !== grouped_price.date)
					{
						return false;
					}
				}

			// If price has an age, same age is required
				if (grouped_price.age || price.age)
				{
					if (price.age !== grouped_price.age)
					{
						return false;
					}
				}

			// If price has a ticket type, same type is required
				if (grouped_price.ticket_type || price.ticket_type)
				{
					if (price.ticket_type !== grouped_price.ticket_type)
					{
						return false;
					}
				}

			// If price has a different comment, it is not grouped
				if (grouped_price.comment && grouped_price.comment.length > 0
					|| price.comment && price.comment.length > 0)
				{
					if (price.type !== 'Prix Public' && grouped_price.comment !== price.comment)
					{
						return false;
					}
				}

			// Gift cards, vouchers
				if (product.pricing_type === 'simple_product')
				{
					let same_type_price = grouped_price._other_prices
					.find(data => data.type === price.type);

					if (typeof same_type_price !== 'undefined')
					{

					// Validity is the same,
					// so it is a different gift card or voucher
						if (!same_type_price.validity_start &&
							!price.validity_start)
						{
							return false;
						}
						else if (same_type_price.validity_start ===
							price.validity_start)
						{
							return false;
						}
					}
				}

				if (price.validity_start || grouped_price.validity_start)
				{
					if (price.validity_start !== grouped_price.validity_start)
					{
						return false;
					}
				}

				if (price.validity_date || grouped_price.validity_date)
				{
					if (price.validity_date !== grouped_price.validity_date)
					{
						return false;
					}
				}

				return true;
			});

			if (parent_price)
			{
				parent_price._other_prices.push(_.cloneDeep(price));
			}
			else
			{
				let inserted_price = _.cloneDeep(price);

				inserted_price._other_prices = [_.cloneDeep(price)];

				grouped_prices.push(inserted_price);
			}
		});

	// Link refered data to prices
		grouped_prices = grouped_prices
		.map(function (price)
		{
			let age = app.getReferedValue(
			{
				model: 'Age',
				references: component.state.references,
				id: price.age
			});

			let position = app.getReferedValue(
			{
				model: 'ShowPosition',
				references: component.state.references,
				id: price.position
			});

			let ticket_type = app.getReferedValue(
			{
				model: 'TicketType',
				references: component.state.references,
				id: price.ticket_type
			});

			let references =
			{
				_age        : age.id ? age : undefined,
				_position   : position.id ? position : undefined,
				_ticket_type: ticket_type.id ? ticket_type : undefined
			};

			price = _.merge(price, references);

			price._other_prices.forEach(function (price)
			{
				price = _.merge(price, references);
			});

			return price;
		});

		grouped_prices = grouped_prices
		.sort
		(
			firstBy(_date)
			.thenBy(_position)
			.thenBy(_age)
		);

		prices = grouped_prices
		.map(function (data, key)
		{
			let classes =
			{
				'Prix CE': 'c-pricing--primary',
				'Prix Spécial': 'c-pricing--important'
			};

			let price_date, position, age, ticket_type;
			let validity_start, validity_date, comment;

			if (component.displayed_columns['date'])
			{
				let date;

				if (data.date)
				{
					date = moment(data.date).format('ddd DD MMM YYYY - HH[h]mm');
				}

				price_date =
				(
					<div className="c-pricing__element age">
						<div className="c-pricing__value date">
							{ date }
						</div>
					</div>
				);
			}

			if (component.displayed_columns['ticket_type'])
			{
				ticket_type =
				(
					<div className="c-pricing__element ticket_type">
						<div className="c-pricing__value ticket_type">
							{ data._ticket_type ? (data._ticket_type.label || '') : '' }
						</div>
					</div>
				);
			}

			if (component.displayed_columns['age'])
			{
				age =
				(
					<div className="c-pricing__element age">
						<div className="c-pricing__value age">
							{ data._age ? (data._age.label || '') : '' }
						</div>
					</div>
				);
			}

			if (component.displayed_columns['position'])
			{
				position =
				(
					<div className="c-pricing__element position">
						<div className="c-pricing__value position">
							{ data._position ? (data._position.label || '') : '' }
						</div>
					</div>
				);
			}

			if (component.displayed_columns['validity_start'])
			{
				let date;

				if (data.validity_start)
				{
					date = moment(data.validity_start).format('DD MMM YYYY');
				}

				validity_start =
				(
					<div className="c-pricing__element validity_start">
						<div className="c-pricing__value date">
							{ date }
						</div>
					</div>
				);
			}

			if (component.displayed_columns['validity_date'])
			{
				let date;

				if (data.validity_date)
				{
					date = moment(data.validity_date).format('DD MMM YYYY');
				}

				validity_date =
				(
					<div className="c-pricing__element validity_end">
						<div className="c-pricing__value date">
							{ date }
						</div>
					</div>
				);
			}

			if (data.comment && data.comment.trim().length > 0)
			{
				comment =
				(
					<div className="c-tooltip c-tooltip--info u-margin-right-15">
						<button className="c-tooltip__btn">i</button>

						<div className="c-tooltip__txt"
							dangerouslySetInnerHTML= { { __html: data.comment } }>
						</div>
					</div>
				);
			}

			let price_lines = [];

			if (data._other_prices instanceof Array)
			{
				price_lines = data._other_prices.map(function (price)
				{
					let displayed_price = price.type.split('Prix ').join('');

					let status_class = '';

					if (price.status === 'canceled')
					{
						displayed_price += ' - annulé';

						status_class += ' ' + price.status;
					}
					else if (price.status === 'full')
					{
						displayed_price += ' - complet';

						status_class += ' ' + price.status;
					}
					else if (price.status === 'ended')
					{
						displayed_price += ' - épuisé';

						status_class += ' ' + price.status;
					}
					else if (price.limit_date &&
						moment(price.limit_date).isBefore(today))
					{
						displayed_price += ' - Fin des ventes chez synergies';

						status_class += ' end-of-sell';
					}
					else
					{
						let price_value = numeral(safeNumeral(price.price)).value();

						if (price_value <= 0)
						{
							displayed_price += ' - offert';
						}
						else
						{
							displayed_price += ' - ' + price.price + ' €';
						}
					}

					let price_data =
					{
						data: price,
						rendered:
						(
							<div className={ 'c-pricing__price-line' + status_class }
								key={ price.ref }>
								{ displayed_price }
							</div>
						)
					};

					return price_data;
				});
			}

		// Order of displayed prices
		// Public first, then Special, then EC, then Synergies
			price_lines = price_lines
			.sort
			(
				firstBy(_availability)
				.thenBy(_type)
			);

			let buy_price = price_lines[price_lines.length-1];

			if (buy_price && buy_price.data &&
			(
				['canceled', 'full', 'ended'].includes(buy_price.data.status) ||
				buy_price.data.limit_date &&
				moment(buy_price.data.limit_date).isBefore(today)
			))
			{
				buy_price = undefined;
			}

			let add_cart;

			if (buy_price && [true, 'true'].includes(state.can_pay))
			{
				add_cart =
				(
					<button type="button"
						className="c-pricing__tag c-model__cart-btn"
						onClick={ function (e) { component.addCart(buy_price.data); } }>
						Ajouter

						<svg className="o-svg-icon o-svg-icon--shopping-cart c-model__cart-icon">
							<use xlinkHref="/images/icons.svg#svg-icon-shopping-cart"></use>
						</svg>
					</button>
				);
			}

			price_lines = price_lines.map(data => data.rendered);

			let special_class = '';

			if (buy_price && buy_price.data)
			{
				special_class = ' ' + (classes[buy_price.data.type] || '');
			}

			let prices;

			if (comment)
			{
				prices =
				(
					<Fragment>

						<div className="u-flex u-content-between u-items-center u-flex-grow-1">

							<div className="c-pricing__value price">
								{ price_lines }
							</div>

						</div>

						{ comment }

					</Fragment>
				);
			}
			else
			{
				prices =
				(
					<div className="c-pricing__value price">
						{ price_lines }
					</div>
				);
			}

			let output =
			(
				<div className={ 'c-pricing ' + special_class }
					key={ key }>

					{ price_date }

					{ ticket_type }

					{ position }

					{ age }

					{ validity_start }

					{ validity_date }

					<div className="c-pricing__element price">
						<div className="u-flex u-flew-wrap u-items-center u-content-between">
							{ prices }

							{ add_cart }
						</div>
					</div>

				</div>
			);

			return output;
		}, -1);

		return prices;

		function _availability (a, b)
		{
			let a_buyable = true, b_buyable = true;

			if (['canceled', 'full', 'ended'].includes(a.data.status) ||
				['true', true].includes(a.data.canceled))
			{
				a_buyable = false;
			}

			if (['canceled', 'full', 'ended'].includes(b.status) ||
				['true', true].includes(b.data.canceled))
			{
				b_buyable = false;
			}

			if (a_buyable && b_buyable === false)
			{
				return 1;
			}

			if (a_buyable === false && b_buyable)
			{
				return -1;
			}

			return 0;
		}

		function _type (a, b)
		{
			if (a.data.type === 'Prix Spécial')
			{
				return 1;
			}
			else if (b.data.type === 'Prix Spécial')
			{
				return -1;
			}

			if (a.data.type === 'Prix Synergies')
			{
				return 1;
			}
			else if (b.data.type === 'Prix Synergies')
			{
				return -1;
			}

			if (a.data.type === 'Prix CE')
			{
				return 1;
			}
			else if (b.data.type == 'Prix CE')
			{
				return -1;
			}

			if (a.data.type === 'Prix Public')
			{
				return 1;
			}
			else if (b.data.type === 'Prix Public')
			{
				return -1;
			}

			return 0;
		}

		function _date (a, b)
		{
			if (a.date === b.date)
			{
				return 0;
			}

			else if (moment(a.date).isAfter(moment(b.date)))
			{
				return 1;
			}

			else if (moment(a.date).isBefore(moment(b.date)))
			{
				return -1;
			}
		}

		function _age (a, b)
		{
			if (a.age === b.age) return 0;

			const a_age = (a._age?.label || '').toLowerCase();
			const b_age = (b._age?.label || '').toLowerCase();

			return a_age.localeCompare(b_age);
		}

		function _position (a, b)
		{
			if (a._position?.label === b._position?.label) return 0;

			const a_pos = (a._position?.label || '').toLowerCase();
			const b_pos = (b._position?.label || '').toLowerCase();

			return a_pos.localeCompare(b_pos);
		}
	}

	getPlaceLabel (place_data)
	{
		let place_label = [];

		let is_line_2_first = false;

		if (typeof place_data.address.line_2 === 'string')
		{
			let line_2 = place_data.address.line_2;

			is_line_2_first = ['Zone', 'ZI', 'ZA', 'Espace']
			.find(function (str)
			{
				return line_2.toLowerCase().indexOf(str.toLowerCase()) !== -1;
			});
		}

		if (place_data.name && place_data.name !== place_data.address.line_1 &&
			place_data.name !== place_data.address.line_2 )
		{
			place_label.push(place_data.name);
		}

		if (is_line_2_first && place_data.address.line_2)
		{
			place_label.push(place_data.address.line_2);
		}

		if (place_data.address.line_1)
		{
			place_label.push(place_data.address.line_1);
		}

		if (!is_line_2_first && place_data.address.line_2)
		{
			place_label.push(place_data.address.line_2);
		}

		if (place_data.address.zip_code)
		{
			place_label.push(place_data.address.zip_code);
		}

		if (place_data.address.city)
		{
			if (place_data.address.zip_code)
			{
				place_label[place_label.length-1] += ' ' + place_data.address.city;
			}
			else
			{
				place_label.push(place_data.address.city);
			}
		}

		if (place_label.length > 1)
		{
			place_label = place_label.join(', ');
		}
		else if (place_label.length === 1 && place_label[0])
		{
			place_label = place_label[0];
		}
		else
		{
			place_label = '';
		}

		return place_label;
	}

	render ()
	{
		const component = this, props = this.props, product = component.state.product;

		const moment = window.moment, state = this.state;

		let loader, product_public, places;

		if (component.state.loading === true)
		{
			loader = <Loader className="c-loader" bemit={ ['primary', 'bg-white', 'big'] } />;
		}

		let images = (product.images || [])
		.map(function (data, index)
		{
			var output =
			(
				<div key={ index }>
					<Image className="c-model__carousel-image" src={ data.url } />
				</div>
			);

			return output;
		});

		const slider_settings =
		{
			dots: true,
			infinite: false,
			speed: 320,
			slidesToShow: 1,
			slidesToScroll: 1,
			swipeToSlide: true,
			useCSS: true,
			breakpoint: 100,
			draggable: true
		};

	/**
	 * Render themes
	 **/
		let themes = (product._theme || [])
		.map(function (theme)
		{
			let output =
			(
				<div className="c-model__theme" key={ theme.id }>
					{ theme.label }
				</div>
			);

			return output;
		});

		if (themes.length > 0)
		{
			themes =
			(
				<div className="c-model__themes">
					{ themes }
				</div>
			);
		}
		else
		{
			themes = undefined;
		}

	/**
	 * Render product public
	 **/
		if (product._public)
		{
			product_public =
			(
				<div className="c-model__themes">
					<div className="c-model__theme">
						Public - { product_public }
					</div>
				</div>
			);
		}

		let prices_header = component.getPricesHeader();

		let prices = component.getPrices();

		if (component.state.loading === false)
		{
			component.gmap_rdy = true;
		}

		let google_map, place_label = '';

	/**
	 * Google Map instantiation
	 */
		if (product._national_brand || product._places && product._places[0])
		{
			place_label = product._national_brand
			? product._national_brand.name
			: component.getPlaceLabel(product._places[0]);

			if (component.gmap_rdy === true)
			{
				let address = product._national_brand ?
				{
					name: product._national_brand.addresses[0]?.name,
					line_1: product._national_brand.addresses[0]?.line_1,
					line_2: product._national_brand.addresses[0]?.line_2,
					zip_code: product._national_brand.addresses[0]?.postal_code,
					city: product._national_brand.addresses[0]?.city,
					label: place_label
				}
				:
				{
					name: product._places[0].name,
					line_1: product._places[0].address.line_1,
					line_2: product._places[0].address.line_2,
					zip_code: product._places[0].address.zip_code,
					city: product._places[0].address.city,
					label: place_label
				};

				const pins = [];

				if (product._national_brand)
				{
					(product._national_brand.addresses || [])
					.forEach(function (address)
					{
						if (address.position)
						{
							address.position.lat = Number(address.position.lat);
							address.position.lng = Number(address.position.lng);

							if (isNaN(address.position.lng) ||
								isNaN(address.position.lat))
							{
								return;
							}

							pins.push(
							{
								position: address.position,
								name: address.name || ''
							});
						}
					});
				}
				else
				{
					(product._places || []).forEach(function (place)
					{
						if (!(place.geocoding || [])[0]) return;

						let [lat, lng] = place.geocoding[0].geometry.location
						.replace('(', '').replace(')', '')
						.split(', ');

						lat = Number(lat);
						lng = Number(lng);

						if (isNaN(lat) || isNaN(lng)) return;

						pins.push(
						{
							position: { lat: lat, lng: lng },
							name: place.name || ''
						});
					});
				}

				google_map =
				(
					<GMap className="c-model__gmap" address={ address }
						pins={ pins }
					/>
				);
			}
		}

		const localisation = product._national_brand || (product._places || [])[0] ?
		(
			<div className="c-model__map">
				{ google_map }
			</div>
		)
		: undefined;

	/**
	 * Display only tabs with data
	 *
	 * @type    { Array }
	 **/
		let tabs = state.tabs
		.filter(function (tab_infos, key)
		{
			if (tab_infos.name === 'artist')
			{
				if (!product._artist) return false;
			}
			else if (tab_infos.name === 'places')
			{
				if (product._national_brand) return true;

				if (!product._places) return false;

				return product._places.length > 0;
			}
			else if (tab_infos.name === 'images')
			{
				if (images.length <= 0) return false;
			}
			else if (tab_infos.name === 'custom_quote')
			{
				if (!Array.isArray(product.custom_quotes) || !product.custom_quotes[0])
				{
					return false;
				}
			}

			return true;
		})
		.map(function (tab_infos, key)
		{
			let label = tab_infos.label;

			if (tab_infos.name === 'places')
			{
				if (product._national_brand || (product.places || []).length > 1)
				{
					label = 'Localisations';
				}
				else if (product._places && product._places[0])
				{
					label = product._places[0].name;
				}
			}

			let output =
			(
				<button key={ key } onClick={ function (e)
					{ component.setState({ active_tab: tab_infos.name }) } }
					className={ 'c-tab' + (state.active_tab === tab_infos.name ?
					' c-tab--active' : '') }>

					<div className="c-tab__label">
						{ label }
					</div>

				</button>
			);

			return output;
		});

		let content;

		if (state.active_tab === 'prices')
		{
			if (!images[0] && product._artist && product._artist.images[0])
			{
				images[0] =
				(
					<div key={ 1 }>
						<Image className="c-model__carousel-image"
							src={ product._artist.images[0].url } />
					</div>
				);
			}

			let place_infos;

			if (product._places && product._places[0] &&
				product._places.length <= 1 && place_label)
			{
				place_infos =
				(
					<div className="c-model__places u-margin-top-20">
						<svg className="o-svg-icon o-svg-icon--tracker c-model__places-icon">
							<use xlinkHref="/images/icons.svg#svg-icon-tracker"></use>
						</svg>

						{ place_label }
					</div>
				);
			}

			let description = (product.description || '')
			.split('<p><br></p>')
			.join('')
			.split('rel="noopener noreferrer"')
			.join('');

			let abondement;

			if (state.abondement && isProductAbondable(product, state.abondement))
			{
				abondement =
				(
					<div className="c-message c-message--orange">
						<div className="c-message__content">
							Profitez de
							{ ' ' }
							{ formatNum(state.abondement.value, '0,0[.]00') }
							&nbsp;€ d'abondement sur ce produit&nbsp;!
						</div>
					</div>
				);
			}

			let pdf_files = (product.pdfs || [])
			.filter(data => Boolean(data))
			.map(function (file, i)
			{
				let output =
				(
					<div className="u-full-width u-margin-top-10" key={ i }>
						<Link href={ file.url } type="application/pdf" target="_blank">
							{ file.filename }
						</Link>
					</div>
				);

				return output;
			});

			let pdf_files_title;

			if (pdf_files.length > 0)
			{
				pdf_files_title =
				(
					<div className="c-subtitle u-margin-top-30">
						<div className="c-subtitle__txt">
							{
								'Document' +
								(pdf_files.length > 1 ? 's' : '') +
								' à télécharger'
							}
						</div>
					</div>
				);
			}

			const is__gift = (product.place_themes || [])
			.includes('5a664f2b464daed256b231baz');

			const prices_table = state.can_access_partners === false && is__gift ? getFormStatus(
			{
				warning: 'Votre CSE ne propose pas cette offre.'
			})
			: state.can_access_partners !== undefined ?
			(
				<div className="u-full-width u-responsive-table">

					<div className="c-model__prices">

						<div className="c-pricing c-pricing--header">
							{ prices_header }
						</div>

						{ prices }

					</div>

				</div>
			)
			: undefined;

			const online_type = getOnlineType(product.online_type);

			content =
			(
				<div className="c-model__body">

					<div className="o-content">

						<div className="c-subtitle u-margin-top-0">
							<h2 className="c-subtitle__txt">
								{ product.name }
							</h2>
						</div>

						{ product_public }

					</div>

					<div className="o-grid o-grid--wrap-tablet">

						<div className="o-grid__item-8">

							{ abondement }

							{ place_infos }

							{
								online_type ?
								(
									<div className="u-full-width u-text-right">
										<div className="c-model__online-type">
											{ online_type }
										</div>
									</div>
								)
								: undefined
							}

							{ prices_table }

							<div className="c-model__description"
								dangerouslySetInnerHTML= { { __html: description } }>
							</div>

						</div>

						<div className="o-grid__item-4">

							{ themes }

							<div className="c-model__image">
								{ images[0] || undefined }
							</div>

							{ pdf_files_title }

							{ pdf_files }

						</div>

					</div>

				</div>
			);
		}
		else if (state.active_tab === 'places')
		{
			let places_list = product._places || [];

			places = places_list.map(function (place)
			{
				place.infos = place.infos || { };

				let links =
				[
					place.infos.twitter,
					place.infos.facebook,
					place.infos.website,
					place.infos.instagram
				];

				links = links
				.map(function (link, i)
				{
					if (!link || link.trim() === '') return undefined;

					if (link.indexOf('http') === -1)
					{
						if (i < 2)
						{
							link = 'https://' + link;
						}
						else
						{
							link = 'http://' + link;
						}
					}
					else if (link.indexOf('https') === -1 && i !== 2)
					{
						link = link.replace('http', 'https');
					}

					return link;
				});

				let email     = place.infos.email, phone = place.infos.phone;
				let twitter   = links[0], facebook = links[1], website = links[2];
				let instagram = links[3];

				if (twitter)
				{
					twitter =
					(
						<a className="c-model__social" href={ twitter }
							target="_blank" rel="noreferrer">
							<svg className="o-svg-icon o-svg-icon--twitter c-model__social-icon">
								<use xlinkHref="/images/icons.svg#svg-icon-twitter"></use>
							</svg>
						</a>
					);
				}

				if (facebook)
				{
					facebook =
					(
						<a className="c-model__social" href={ facebook }
							target="_blank" rel="noreferrer">
							<svg className="o-svg-icon o-svg-icon--facebook c-model__social-icon">
								<use xlinkHref="/images/icons.svg#svg-icon-facebook"></use>
							</svg>
						</a>
					);
				}

				if (instagram)
				{
					instagram =
					(
						<a className="c-model__social" href={ instagram }
							target="_blank" rel="noreferrer">
							<svg className="o-svg-icon o-svg-icon--instagram c-model__social-icon">
								<use xlinkHref="/images/icons.svg#svg-icon-instagram"></use>
							</svg>
						</a>
					);
				}

				if (website)
				{
					website =
					(
						<div className="c-model__social-media">
							<a className="c-model__social" href={ website }
								target="_blank" rel="noreferrer">
								<svg className="o-svg-icon o-svg-icon--website c-model__social-icon">
									<use xlinkHref="/images/icons.svg#svg-icon-website"></use>
								</svg>

								<div className="c-model__social-text">
									Site web&nbsp;:
									{
										' ' +
										website
										.replace('http://', '')
										.replace('https://', '')
										.replace('www.', '')
									}
								</div>
							</a>
						</div>
					);
				}

				if (email)
				{
					email =
					(
						<div className="c-model__social-media">
							<a className="c-model__social"
								target="_blank" rel="noreferrer" href=
								{
									( email.indexOf('@') !== -1 ? ('mailto:' + email) : email)
								}>
								<svg className="o-svg-icon o-svg-icon--mail c-model__social-icon">
									<use xlinkHref="/images/icons.svg#svg-icon-mail"></use>
								</svg>

								<div className="c-model__social-text">
									{
										' ' +
										email
										.replace('http://', '')
										.replace('https://', '')
										.replace('www.', '')
									}
								</div>
							</a>
						</div>
					);
				}

				if (phone)
				{
					phone =
					(
						<a className="c-model__social" href={ 'tel:' + email }>
							<svg className="o-svg-icon o-svg-icon--phone c-model__social-icon">
								<use xlinkHref="/images/icons.svg#svg-icon-phone"></use>
							</svg>

							<div className="c-model__social-text">
								{
									' ' + app.getSpacedPhoneNumber(phone)
								}
							</div>
						</a>
					);
				}

				let place_label = component.getPlaceLabel(place);

				let social_medias;

				if (twitter && facebook && instagram)
				{
					social_medias =
					(
						<div className="c-model__social-media u-flex u-content-center">
							{ twitter }
							{ facebook }
							{ instagram }
						</div>
					);
				}

				let description;

				if (place.description)
				{
					description = (place.description || '')
						.split('<p><br></p>').join('');

					description =
					(
						<div className="c-model__place-description"
							dangerouslySetInnerHTML={ { __html: description } }>
						</div>
					);
				}

				let images, slider;

				if (place.images && place.images.length > 0)
				{
					images = (place.images || []).map(function (data, index)
					{
						let output =
						(
							<div key={ index }>
								<Image className="c-model__place-carousel-image"
									src={ data.url } />
							</div>
						);

						return output;
					});

					slider =
					(
						<div className="c-model__place-images">
							<Slider { ...slider_settings }>
								{ images }
							</Slider>
						</div>
					);
				}

				let output =
				(
					<div className="o-grid__item u-flex" key={ place.id }>

						<div className="c-model__place-infos">
							<div className="c-model__social-media">
								<div className="c-model__social-media-title">
									<svg className="o-svg-icon o-svg-icon--tracker c-model__places-icon">
										<use xlinkHref="/images/icons.svg#svg-icon-tracker"></use>
									</svg>
									{ place_label }
								</div>
							</div>

							{ website }

							{ email }

							{ phone }

							{ social_medias }

							{ description }

						</div>

					</div>
				);

				return output;
			});

			content =
			(
				<div className="c-model__body">
					<div className="c-subtitle u-margin-top-0">
						<h2 className="c-subtitle__txt">
							Où profiter de ce produit&nbsp;?
						</h2>
					</div>

					{ localisation }

					<div className="u-negative-margins">
						<div className="o-grid-2 u-margin-top-20">
							{ places.length ? places : undefined }
						</div>
					</div>

				</div>
			);
		}
		else if (state.active_tab === 'images' && images.length)
		{
			content =
			(
				<div className="c-model__body">

					<div className="o-grid">

						<div className="o-grid__item-12">

							<div className="c-model__images">
								<Slider { ...slider_settings }>
									{ images }
								</Slider>
							</div>

						</div>

					</div>

				</div>
			);
		}
		else if (state.active_tab === 'artist' && product._artist)
		{
			let description = (product._artist.description || '')
				.split('<p><br></p>').join('');

			let artist_images = (product._artist.images || []).map(function (data, index)
			{
				var output =
				(
					<div key={ index }>
						<Image className="c-model__carousel-image" src={ data.url } />
					</div>
				);

				return output;
			});

			let artist_slider;

			if (artist_images.length)
			{
				artist_slider =
				(
					<div className="o-grid__item-4">

						<div className="c-model__images">
							<Slider { ...slider_settings }>
								{ artist_images }
							</Slider>
						</div>

					</div>
				);
			}

			content =
			(
				<div className="c-model__body">

					<div className="c-subtitle">
						<div className="c-subtitle__txt">
							{ product._artist.name }
						</div>
					</div>

					<div className="o-grid">

						<div className={ 'o-grid__item-' + (artist_slider ? '8' : '12') }>
							<div className="c-model__description"
								dangerouslySetInnerHTML= { { __html: description } }>
							</div>
						</div>

						{ artist_slider }

					</div>

				</div>
			);
		}
		else if (state.active_tab === 'custom_quote')
		{
			content = product.custom_quotes.map(function (quote)
			{
				let output =
				(
					<Fragment key={ quote.id }>

						<div className="c-subtitle u-margin-bottom-20">
							<div className="c-subtitle__txt">
								{ quote.title || 'Demande de devis' }
							</div>
						</div>

						<FrontCustomQuote elements={ quote.elements } quote={ quote } />

					</Fragment>
				);

				return output;
			});

			content =
			(
				<div className="c-model__body">
					{ content }
				</div>
			);
		}

		let output =
		(
			<Layout page_title={ product.name || '' } history={ props.history }>

				<div className="page-content c-model c-model--product">

					<HolidaysMessage />

					<div className="c-model__content-wrapper">

						<div className="c-model__tabs">{ tabs }</div>

						<div className="c-model__content">
							{ content }
						</div>

						{ loader }

					</div>

				</div>

			</Layout>
		);

		return output;
	}
}
